import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { INavData } from '@coreui/angular-pro';
import { MenuModel } from '@domain/models/general/menu.model';
import { KeycloakService } from 'keycloak-angular';

/**
 *Gestiona la cuenta del usuario, accesos y realiza las comprobaciones de validación.
 *
 * @author Jose Manuel Landero Gonzalez
 * @export
 * @class AccountService
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private permissions: string[] = []; 

  constructor() {
    
  }

  /**
   *Valida si el permiso solicitado esta registrado
   *
   * @param {string} permissions
   * @return {*}  {boolean}
   * @memberof PermissionsService
   */
  hasPermission(permissions: string): boolean {
    return this.permissions.includes(permissions);
  }

  /**
   *Registra todos los permisos
   *
   * @param {string[]} permissions
   * @memberof PermissionsService
   */
  setPermissions(permissions: string[]): void {
    this.permissions = permissions;
  }
  
  /**
   *Agregar un permiso al registro
   *
   * @param {string} permission
   * @memberof PermissionsService
   */
  addPermission(permission: string) {
    this.permissions.push(permission);
  }

  /**
   *Eliminar un permiso del registro
   *
   * @param {string} permission
   * @memberof PermissionsService
   */
  removePermission(permission: string){
    this.permissions.splice(this.permissions.indexOf(permission), 1);
  }

  /**
   *Limpia los registros de permisos
   *
   * @memberof PermissionsService
   */
  cleanPermissions(): void {
    this.permissions = [];
  }

    /**
   *Ver todos los permisos
   *
   * @return {*}  {string[]}
   * @memberof PermissionsService
   */
   getPermissions(){
    return this.permissions;
   }
}
